import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

var renderCounter = 0;

function DisplayDate(props) {
  let date = props.value;
  date = date.substr(date.indexOf('-') + 1);
  return <>{date}</>;
}

export default function DisplayOptionChoices(props) {
  let options = [];
  let userOptionChoices = props.optionChoices.choices;
  let availableChains = props.optionChains.chains;
  if (userOptionChoices !== undefined) {
    let mappedAvailableChains = {};
    for (let num in availableChains) {
      let chainWithDate = availableChains[num];
      for (let date in chainWithDate) {
        let chain = chainWithDate[date];
        chain.forEach((o) => {
          let option = o; /* JSON.parse(o); */
          if (!mappedAvailableChains[date]) {
            mappedAvailableChains[date] = {};
          }
          mappedAvailableChains[date][option.symbol] = option;
        });
      }
    }

    Object.keys(userOptionChoices).forEach((date) => {
      let choicesPerChain = userOptionChoices[date];
      choicesPerChain.forEach((optionSymbol) => {
        if (mappedAvailableChains[date]) {
          if (mappedAvailableChains[date][optionSymbol]) {
            let option = mappedAvailableChains[date][optionSymbol];
            options.push(option);
          }
        }
      });
    });
  }
  return (
    <div>
      <OptionChoicesTable options={options} />
    </div>
  );
}

class OptionChoicesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnNames: [
        {
          headerName: 'optionChoices',
          children: [
            {
              headerName: 'option_type',
              field: 'option_type',
              resizable: true,
              //cellRenderer: "firstLetterOptionType",
            },
            {
              headerName: 'strike',
              field: 'strike',
              resizable: true,
            },
            {
              headerName: 'date',
              field: 'expiration_date',
              resizable: true,
              cellRenderer: 'displayDate',
            },
          ],
        },
      ],
      frameworkComponents: {
        displayDate: DisplayDate,
      },
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi = params.columnApi;
    //if not done like this but rather through the component, seems to lose previous set data
    var allColIds = params.columnApi
      .getAllColumns()
      .map((column) => column.colId);
    params.columnApi.autoSizeColumns(allColIds);
  }

  render() {
    return (
      <div>
        <div
          className="ag-theme-balham"
          style={{ height: '250px', width: '275px' }}
        >
          <AgGridReact
            ref="agGrid"
            columnDefs={this.state.columnNames}
            rowData={this.props.options}
            onGridReady={this.onGridReady.bind(this)}
            frameworkComponents={this.state.frameworkComponents}
          />
        </div>
      </div>
    );
  }
}
